module.exports = __webpack_public_path__ + "static/media/seguimiento.50f80c99.svg";